import type { PostApiV1RefundsRequest200AllOfThreeData } from './postApiV1RefundsRequest200AllOfThreeData';

export type PostApiV1RefundsRequest200AllOfThree = {
  data?: PostApiV1RefundsRequest200AllOfThreeData;
};
